import styled from 'styled-components';

export const CheckmarkStyles = styled.div`
  .checkmark {
    fill: none;
    margin-left: 7px;
    margin-bottom: -2px;

    stroke: ${(props) => (props.strokeColor ? props.strokeColor : '#FFFFFF')};

    stroke-width: 5px;

    path {
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }
`;
